import { WHO_IN_HEALTH_COMMUNITY_SECTION, HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION, FORUM_HEALTH_COMMUNITY_SECTION } from '@/constants/healthyCommunitySections'
import { getBaseDomain } from '@/helpers/global.helpers'
import { ES_LOCALE } from '@/constants/locales'
import { firstLetterUppercase } from '@/helpers/string.helpers'
import accountRepository from '@/repositories/AccountRepository'

export default {
	computed: {
		basePathForumName () {
			return location.href.indexOf('comunidadsaludable') > -1 ? 'comunidadsaludable' : 'foro'
		},
    inWhoInSection () {
      return this.$store.state.forum.sectionId === WHO_IN_HEALTH_COMMUNITY_SECTION
    }
	},
  methods: {
    getTimeAgoFromDate (date) {
      let diff = Math.abs(new Date() - new Date(date)) / 1000
      let result = diff < 60 ? `${Math.floor(diff)} ${this.$t('seconds')}` : diff / 60 < 60 ? `${Math.floor(diff / 60)} ${this.$t('minutes')}` : diff / 60 / 60 < 24 ? `${Math.floor(diff / 60 / 60)} ${this.$t('hours')}` : diff / 60 / 60 / 24 < 30 ? `${Math.floor(diff / 60 / 60 / 24)} ${this.$t('days')}` : diff / 60 / 60 / 24 / 30 < 12 ? `${Math.floor(diff / 60 / 60 / 24 / 30)} ${this.$t('months')}` : `${Math.floor(diff / 60 / 60 / 24 / 30 / 12)} ${this.$t('years')}`
      if (result.split(' ')[0] === '1') {
        if(result.split(' ')[1].indexOf(this.$t('months')) > -1) {
          result = result.slice(0, -2)
        } else {
          result = result.slice(0, -1)
        }
      }
      let lang = this.$i18n.locale
      if (lang === 'en') {
        return `${result} ${this.$t('ago')}`
      } else {
        return `${this.$t('ago')} ${result}`
      }
    },
    getUserBasicInfo () {
      let _this = this
      this.$api.get('/Forum/GetUserBasicInfo').then((response) => {
        if (response.response && (response.response.status === 401 || response.response.status === 500)) {
          this.logOff(true)
          return
        }
        if (response.data) {
          if (response.data.error) {
            switch (response.data.error) {
              case 'forbiddenMinorUser':
                this.$store.dispatch('showDangerAlert', this.$t('forbiddenMinorUser'))
                setTimeout(function () {
                  _this.logOff()
                }, 5000)
            }
            return
          }
          this.getUserLoginInfo()
          this.$store.state.forum.userBasicInfo = response.data
          if (response.data.pushNotificationsSectionId && response.data.pushNotificationsSectionId.length > 0) {
            this.$store.state.forum.numberPushNotifications = response.data.pushNotificationsSectionId.length
          }
          if (response.data.companyCode && response.data.companiesAccessRestricted && location.href.indexOf('comunidadsaludable') > -1) {
            this.$store.dispatch('showDangerAlert', this.$t('companiesAccessRestrictedMessage'))
            setTimeout(() => {
              location.href = this.$helpers.getHealthyCommunityUrl('pacientescomotu')
            }, 5000)
          }
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    getUserLoginInfo () {
      accountRepository.getSession().then(response => {
        this.$store.dispatch('session/set', response.data)
      })
    },
    loadForumEntries () {
      if (this.$store.state.forum.showingSearch) {
        this.$api.get(`/Forum/SearchEntry`, {params: { id: this.$store.state.forum.searchId, type: this.$store.state.forum.searchType, sectionId: this.$store.state.forum.sectionId, page: this.$store.state.forum.entriesPageNumber, itemsPerPage: this.$store.state.forum.entriesPerPage, sortId: this.$store.state.forum.searchSort }}).then((response) => {
          this.processForumEntry(response.data)
        })
      } else {
        this.$api.get('/Forum/GetEntry', {params: {pageNumber: this.$store.state.forum.entriesPageNumber, itemsPerPage: this.$store.state.forum.entriesPerPage, sortId: this.$store.state.forum.searchSort, sectionId: this.$store.state.forum.sectionId}}).then((response) => {
          this.processForumEntry(response.data)
        })
      }
    },
    processForumEntry (data) {
      if (data) {
        this.$store.state.forum.articleData = this.$store.state.forum.entriesPageNumber ? this.$store.state.forum.articleData.concat(data.entryData) : data.entryData
        this.$store.state.forum.numEntries = data.numEntries
        this.$store.state.forum.entriesCreatedByUser = data.entriesCreatedByUser
      } else {
        this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
      }
    },
    getForumMessages (entryId, pageNumber = 0) {
      this.$api.get('/Forum/GetEntryMessage', {params: {entryId: entryId, pageNumber: pageNumber, itemsPerPage: this.$store.state.forum.messagesPerPage}}).then((response) => {
        if (response.data) {
          this.$store.state.forum.entryMessagesCreatedByUser = response.data.entryMessagesCreatedByUser
          if (pageNumber > 0) {
            this.$store.state.forum.messages.splice(this.$store.state.forum.messages.length, 0, ...response.data.entryMessageData)
          } else {
            this.$store.commit('forum/resetMessagesValues')     
            this.$store.state.forum.messages = response.data.entryMessageData
          }
        } else {
          this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
        }
      })
    },
    showPushNotifications (sectionId) {
      this.$api.get('/Forum/GetPushNotifications').then((response) => {
        if (response.data && response.data.length > 0) {
          this.$store.state.forum.pushNotifications = response.data
          if (response.data.some((x) => x.readed !== true)) {
            this.pushNotificationsReaded()
          }
        }
        if (sectionId) {
          this.$store.state.forum.pushNotifications.filter(x => x.sectionId === sectionId).forEach(x => x.markedSectionId = sectionId)
        }
        this.$store.state.forum.showPushNotificationsModal = true
      })
    },
    pushNotificationsReaded (sectionId) {
      this.$api.put('/Forum/PushNotificationsReaded', null, {params: {sectionId: sectionId}}).then((response) => {
        if (!sectionId) {
          this.$store.state.forum.numberPushNotifications = 0
        }
      })
    },
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      this.$fileHelpers.uploadFile('/Forum/ResizeImageToBase64', null, file).then((response) => {
        Editor.insertEmbed(cursorLocation, 'image', response.data)
        resetUploader()
      })
    },
    getPathUrl (path, section, goRoot) {
      path = path ? path : ''
      if (location.href.includes('comunidadsaludable')) {
        let forumSection = goRoot ? '' : section ? `${section}/` : this.$route.params.forumSection ? `${this.$route.params.forumSection}/` : ''
        return `/${(location.href.includes('localdesarrollo') ? 'comunidadsaludable/' : '')}${forumSection}${path}`
      } else if (location.href.includes('localdesarrollo')) {
        return `/foro/${path}`
      } else {
        return `/${path}`
      }
    },
    getHealthyCommunityPathUrl (path) {
      path = path ? path : ''
      if (location.href.includes('localdesarrollo')) {
        return `/comunidadsaludable/${path}`
      } else {
        return `/${path}`
      }
    },
    createNewPost (data) {
      this.$store.commit('forum/toggleCreateNewPost', data)
      this.$router.push(this.getHealthyCommunityPathUrl('new'))
    },
    inHealthyCommunity () {
      return location.href.indexOf('comunidadsaludable') > -1
    },
    logIn (healthyCommunityPath) {
      let _this = this
      this.$store.commit('session/setLoginCallback', function () {
        if (healthyCommunityPath) {
          _this.$router.push(healthyCommunityPath).catch(() => {})
        } else {
          _this.$router.push(_this.getPathUrl()).catch(() => {})
        }
      })
      this.$router.push('/inicio-sesion')
    },
    logOff () {
      this.$api.get('/Forum/LogOff').then((response) => {
        window.$cookies.remove('api_token', null, getBaseDomain())      
        location.href = this.getPathUrl(null, null, true)
      })
    },
    goRoot () {
      this.$router.push(this.getPathUrl()).catch(() => {})
    },
    normalizeForumProp (prop) {
      if (this.$i18nHelpers.getNormalizedLocale() === ES_LOCALE) return prop
      return `${prop}${firstLetterUppercase(this.$i18nHelpers.getNormalizedLocale())}`
    },
    getForumSectionByPath (pathName) {
      switch (pathName) {
        case 'quienseapunta':
          return WHO_IN_HEALTH_COMMUNITY_SECTION
        case 'informacionsalud':
          return HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION
        case 'pacientescomotu':
          return FORUM_HEALTH_COMMUNITY_SECTION
      }
    },
    getForumPathBySectionId (sectionId) {
      switch (sectionId) {
        case WHO_IN_HEALTH_COMMUNITY_SECTION:
          return 'quienseapunta'
        case HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION:
          return 'informacionsalud'
        case FORUM_HEALTH_COMMUNITY_SECTION:
          return 'pacientescomotu'
      }
    },
    getForumSectionTitle (sectionId, includeArticle) {
      switch (sectionId) {
        case WHO_IN_HEALTH_COMMUNITY_SECTION:
          return `${(includeArticle ? this.$t('in') + ' ' : '')}${this.$t('whoIn')}`
        case HEALTHY_INFORMATION_HEALTH_COMMUNITY_SECTION:
          return `${(includeArticle ? this.$t('in') + ' ' : '')}${this.$t('healthyInformation')}`
        case FORUM_HEALTH_COMMUNITY_SECTION:
          return `${(includeArticle ? this.$t('in') + ' ' : '')}${this.$t('patientsLikeYou')}`
        default:
          return `${(includeArticle ? this.$t('in') + ' ' : '')}${this.$t('patientsLikeYou')}`
      }
    },
    canModifyForumEntry (entryId) {
      return this.$store.state.forum.entriesCreatedByUser.includes(entryId) || this.$store.getters['forum/forumUserIsAdminRole'] || this.$store.getters['forum/forumUserIsAdminRestrictedRole']
    },
    canModifyForumMessage (messageId) {
      return this.$store.state.forum.entryMessagesCreatedByUser.includes(messageId) || this.$store.getters['forum/forumUserIsAdminRole'] || this.$store.getters['forum/forumUserIsAdminRestrictedRole']
    },
    canEditForumMessage (messageId) {
      return this.$store.state.forum.entryMessagesCreatedByUser.includes(messageId)
    },
    canEditForumEntry (entryId) {
      return this.$store.state.forum.entriesCreatedByUser.includes(entryId)
    },
    updateLastInteractionDate (entryId) {
      this.$store.state.forum.articleData.find(item => item.id === entryId).lastInteractionDate = new Date()
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/forum.mixin.js